export const actionTypes = {
  ACCOUNT_DETAIL_SAVE_SUCCESS: 'ACCOUNT_DETAIL_SAVE_SUCCESS',
  ACCOUNT_DETAIL_SAVE_FAILURE: 'ACCOUNT_DETAIL_SAVE_FAILURE',
  ACCOUNT_DETAIL_FETCH_SUCCESS: 'ACCOUNT_DETAIL_FETCH_SUCCESS',
  ACCOUNT_DETAIL_FETCH_FAILURE: 'ACCOUNT_DETAIL_FETCH_FAILURE',
};
